export default "__VITE_ASSET__290a1c6f__"